var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M2.572.214c-.313.33-.596.682-.878 1.034l.079.067c-.048.082-.023.105-.022.147.05.079.097.141.137.167l.063-.016.092.051v.09l.146.132.056-.02.089.089.001.058.135.112.045-.033.135.132-.022.059.403.333c.055.133.09.264.08.387-.12.224-.309.507-.573.652.39.414.803.784 1.215 1.158.121.046.225.101.325.158.02.1.038.196.057.337-.03.122-.123.225-.225.326l-.596 1.17.09.18-.137-.052-.133.13c.376.382.81.765 1.237 1.147l.079-.045c.073.05.072.115.28.135.285-.335.441-.819.653-1.237.135-.376.27-.747.405-1.113.114-.125.215-.304.475-.29.269.103.38.171.66.132-.187-.282-.127-.5-.078-.72l.315-.775-.574-.517-.078.022-1.26-1.17-.056.023-.811-.734.024-.065Zm.822 2.934c.012 0 .025 0 .038.002.263.195.465.389.697.583-.112.375-.423.452-.742.473.33.333.628.054 1.046-.197l.124.112a.573.573 0 0 1-.017.478l-.371.191-.388-.117-.923-.827-.033-.225.309-.41c.086-.024.171-.063.26-.063z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondary);
export default __webpack_public_path__ + "static/media/secondary.e0f2b4c921e5a240f0db2f687cf4acbd.svg";
export { ForwardRef as ReactComponent };